import apiCall, { endpoints } from './api';

/**
 * Service pour la gestion des utilisateurs
 * ✅ Utilise les vrais endpoints du backend AdminController et ManagerController
 */
export const userService = {
  /**
   * ✅ Récupérer les utilisateurs d'une boutique (endpoint existant)
   * Le backend attend: page, size, sortBy, sortDirection (pas role/status en paramètres)
   */
  getUsersByBoutique: async (boutiqueId, options = {}) => {
    try {
      // ✅ CORRIGÉ: Utiliser les bons paramètres du backend
      const params = {
        page: options.page || 0,
        size: options.size || 50,
        sortBy: options.sortBy || 'lastName', // ✅ Le backend attend 'lastName'
        sortDirection: options.sortDirection || 'ASC' // ✅ Le backend attend 'sortDirection'
        // ❌ Ne PAS envoyer role et status en paramètres - le backend ne les gère pas
      };

      console.log('🔍 Récupération utilisateurs boutique:', boutiqueId, 'params:', params);

      const response = await apiCall.get(
        endpoints.admin.users.byBoutique(boutiqueId), 
        params
      );
      
      console.log('📥 Réponse getUsersByBoutique:', response);
      return response;
    } catch (error) {
      console.error('❌ Erreur getUsersByBoutique:', error);
      return {
        success: false,
        message: 'Erreur lors de la récupération des utilisateurs'
      };
    }
  },

  /**
   * ✅ NOUVEAU: Récupérer les employés de la boutique du manager connecté
   * Utilise l'endpoint /manager/employees
   */
  getEmployees: async () => {
    try {
      console.log('👥 Récupération des employés via /manager/employees...');
      
      const response = await apiCall.get(endpoints.manager.employees.list);
      console.log('📥 Réponse getEmployees:', response);
      
      if (response.success) {
        const employees = response.data || [];
        console.log('✅ Employés récupérés:', employees.length);
        return response;
      } else {
        throw new Error(response.message || 'Erreur lors de la récupération des employés');
      }
    } catch (error) {
      console.error('❌ Erreur getEmployees:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la récupération des employés'
      };
    }
  },

  /**
   * ✅ NOUVEAU: Créer un employé (pour les managers)
   * Utilise l'endpoint /manager/employees
   */
  createEmployee: async (employeeData) => {
    try {
      console.log('👤 Création employé via /manager/employees:', employeeData);
      
      const response = await apiCall.post(endpoints.manager.employees.create, employeeData);
      console.log('📥 Réponse createEmployee:', response);
      
      if (response.success) {
        console.log('✅ Employé créé avec succès:', response.data);
        return response;
      } else {
        throw new Error(response.message || 'Erreur lors de la création de l\'employé');
      }
    } catch (error) {
      console.error('❌ Erreur createEmployee:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la création de l\'employé'
      };
    }
  },

  /**
   * ✅ NOUVEAU: Mettre à jour un employé (pour les managers)
   * Utilise l'endpoint /manager/employees/{id}
   */
  updateEmployee: async (employeeId, employeeData) => {
    try {
      console.log('🔄 Mise à jour employé via /manager/employees:', employeeId, employeeData);
      
      const response = await apiCall.put(endpoints.manager.employees.update(employeeId), employeeData);
      console.log('📥 Réponse updateEmployee:', response);
      
      if (response.success) {
        console.log('✅ Employé mis à jour avec succès:', response.data);
        return response;
      } else {
        throw new Error(response.message || 'Erreur lors de la mise à jour de l\'employé');
      }
    } catch (error) {
      console.error('❌ Erreur updateEmployee:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la mise à jour de l\'employé'
      };
    }
  },

  /**
   * ✅ NOUVEAU: Désactiver un employé (pour les managers)
   * Utilise l'endpoint /manager/employees/{id}/deactivate
   */
  deactivateEmployee: async (employeeId) => {
    try {
      console.log('🚫 Désactivation employé via /manager/employees:', employeeId);
      
      const response = await apiCall.post(endpoints.manager.employees.deactivate(employeeId));
      console.log('📥 Réponse deactivateEmployee:', response);
      
      if (response.success) {
        console.log('✅ Employé désactivé avec succès');
        return response;
      } else {
        throw new Error(response.message || 'Erreur lors de la désactivation de l\'employé');
      }
    } catch (error) {
      console.error('❌ Erreur deactivateEmployee:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la désactivation de l\'employé'
      };
    }
  },

  /**
   * ✅ Créer un nouvel utilisateur
   */
  createUser: async (userData) => {
    try {
      console.log('👤 Création utilisateur:', userData);
      
      const response = await apiCall.post(endpoints.admin.users.create, userData);
      console.log('📥 Réponse createUser:', response);
      
      return response;
    } catch (error) {
      console.error('❌ Erreur createUser:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la création de l\'utilisateur'
      };
    }
  },

  /**
   * ✅ Mettre à jour un utilisateur
   */
  updateUser: async (userId, userData) => {
    try {
      console.log('🔄 Mise à jour utilisateur:', userId, userData);
      
      const response = await apiCall.put(endpoints.admin.users.update(userId), userData);
      console.log('📥 Réponse updateUser:', response);
      
      return response;
    } catch (error) {
      console.error('❌ Erreur updateUser:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la mise à jour de l\'utilisateur'
      };
    }
  },

  /**
   * ✅ Désactiver un utilisateur
   */
  deactivateUser: async (userId) => {
    try {
      console.log('🚫 Désactivation utilisateur:', userId);
      
      const response = await apiCall.post(endpoints.admin.users.deactivate(userId));
      console.log('📥 Réponse deactivateUser:', response);
      
      return response;
    } catch (error) {
      console.error('❌ Erreur deactivateUser:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la désactivation de l\'utilisateur'
      };
    }
  },

  /**
   * ✅ Réactiver un utilisateur
   */
  reactivateUser: async (userId) => {
    try {
      console.log('✅ Réactivation utilisateur:', userId);
      
      const response = await apiCall.post(endpoints.admin.users.reactivate(userId));
      console.log('📥 Réponse reactivateUser:', response);
      
      return response;
    } catch (error) {
      console.error('❌ Erreur reactivateUser:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la réactivation de l\'utilisateur'
      };
    }
  },

  /**
   * 🔄 Récupérer les utilisateurs de toutes les boutiques
   */
  getAllUsersFromAllBoutiques: async (filters = {}) => {
    try {
      console.log('🔍 Récupération de toutes les boutiques...');
      
      // D'abord récupérer toutes les boutiques
      const boutiquesResponse = await apiCall.get(endpoints.admin.boutiques.list);
      
      if (!boutiquesResponse.success) {
        console.error('❌ Erreur récupération boutiques:', boutiquesResponse);
        return boutiquesResponse;
      }

      const boutiques = boutiquesResponse.data || [];
      console.log('✅ Boutiques récupérées:', boutiques.length);
      
      const allUsers = [];
      
      // Récupérer les utilisateurs de chaque boutique
      for (const boutique of boutiques) {
        console.log(`🔍 Récupération utilisateurs de la boutique: ${boutique.name}`);
        
        const usersResponse = await userService.getUsersByBoutique(boutique.id, {
          page: 0,
          size: 100, // Récupérer plus d'utilisateurs par boutique
          sortBy: 'lastName',
          sortDirection: 'ASC'
        });
        
        if (usersResponse.success) {
          // Le backend peut retourner soit .content (pagination) soit directement les users
          const users = usersResponse.data.content || usersResponse.data.users || usersResponse.data || [];
          
          // Ajouter le nom de la boutique à chaque utilisateur
          const usersWithBoutique = users.map(user => ({
            ...user,
            boutiqueName: boutique.name,
            boutiqueId: boutique.id
          }));
          
          allUsers.push(...usersWithBoutique);
          console.log(`✅ ${users.length} utilisateurs ajoutés de ${boutique.name}`);
        } else {
          console.warn(`⚠️ Erreur récupération utilisateurs de ${boutique.name}:`, usersResponse.message);
        }
      }

      console.log('🎯 Total utilisateurs récupérés:', allUsers.length);

      // Appliquer les filtres côté frontend
      let filteredUsers = allUsers;

      if (filters.role && filters.role !== 'all') {
        filteredUsers = filteredUsers.filter(user => user.role === filters.role);
      }

      if (filters.status && filters.status !== 'all') {
        filteredUsers = filteredUsers.filter(user => {
          const isActive = user.isActive !== undefined ? user.isActive : user.is_active;
          const status = isActive ? 'ACTIVE' : 'INACTIVE';
          return status === filters.status;
        });
      }

      if (filters.boutique && filters.boutique !== 'all') {
        filteredUsers = filteredUsers.filter(user => user.boutiqueId === filters.boutique);
      }

      if (filters.search && filters.search.trim()) {
        const searchTerm = filters.search.toLowerCase().trim();
        filteredUsers = filteredUsers.filter(user =>
          (user.prenom && user.prenom.toLowerCase().includes(searchTerm)) ||
          (user.nom && user.nom.toLowerCase().includes(searchTerm)) ||
          (user.email && user.email.toLowerCase().includes(searchTerm)) ||
          (user.username && user.username.toLowerCase().includes(searchTerm))
        );
      }

      // Tri
      if (filters.sortBy) {
        const { sortBy, sortOrder = 'ASC' } = filters;
        filteredUsers.sort((a, b) => {
          let aValue = a[sortBy];
          let bValue = b[sortBy];

          // Gérer les valeurs null/undefined
          if (aValue == null) aValue = '';
          if (bValue == null) bValue = '';

          // Conversion en string pour comparaison
          aValue = aValue.toString().toLowerCase();
          bValue = bValue.toString().toLowerCase();

          if (sortOrder === 'DESC') {
            return aValue < bValue ? 1 : -1;
          } else {
            return aValue > bValue ? 1 : -1;
          }
        });
      }

      const stats = {
        totalUsers: filteredUsers.length,
        totalManagers: filteredUsers.filter(u => u.role === 'MANAGER').length,
        totalEmployees: filteredUsers.filter(u => u.role === 'EMPLOYEE').length,
        totalActive: filteredUsers.filter(u => {
          const isActive = u.isActive !== undefined ? u.isActive : u.is_active;
          return isActive === true;
        }).length
      };

      return {
        success: true,
        data: {
          users: filteredUsers,
          stats: stats
        },
        message: `${filteredUsers.length} utilisateurs trouvés`
      };

    } catch (error) {
      console.error('❌ Erreur getAllUsersFromAllBoutiques:', error);
      return {
        success: false,
        message: 'Erreur lors de la récupération des utilisateurs'
      };
    }
  },

  /**
   * ⚠️ Méthode principale appelée par UsersList
   * Gère le fait qu'il n'y a pas d'endpoint global /admin/users
   */
  getAllUsers: async (filters = {}) => {
    try {
      console.log('🔍 getAllUsers appelé avec filtres:', filters);
      
      // Si une boutique spécifique est demandée
      if (filters.boutique && filters.boutique !== 'all') {
        console.log('🏪 Récupération pour boutique spécifique:', filters.boutique);
        
        const response = await userService.getUsersByBoutique(filters.boutique, {
          page: filters.page || 0,
          size: filters.size || 50,
          sortBy: filters.sortBy || 'lastName',
          sortDirection: filters.sortOrder || 'ASC'
        });
        
        if (response.success) {
          // Traiter la réponse pour correspondre au format attendu
          const users = response.data.content || response.data.users || response.data || [];
          
          // Appliquer les filtres côté frontend
          let filteredUsers = users;
          
          if (filters.role && filters.role !== 'all') {
            filteredUsers = filteredUsers.filter(u => u.role === filters.role);
          }
          
          if (filters.status && filters.status !== 'all') {
            filteredUsers = filteredUsers.filter(u => {
              const status = u.status || (u.isActive ? 'ACTIVE' : 'INACTIVE');
              return status === filters.status;
            });
          }
          
          if (filters.search && filters.search.trim()) {
            const search = filters.search.toLowerCase().trim();
            filteredUsers = filteredUsers.filter(u => 
              (u.prenom && u.prenom.toLowerCase().includes(search)) ||
              (u.nom && u.nom.toLowerCase().includes(search)) ||
              (u.email && u.email.toLowerCase().includes(search))
            );
          }
          
          const stats = {
            totalUsers: filteredUsers.length,
            managers: filteredUsers.filter(u => u.role === 'MANAGER').length,
            employees: filteredUsers.filter(u => u.role === 'EMPLOYEE').length,
            activeUsers: filteredUsers.filter(u => u.status === 'ACTIVE' || u.isActive === true).length
          };
          
          return {
            success: true,
            data: {
              users: filteredUsers,
              stats: stats
            },
            message: `${filteredUsers.length} utilisateurs trouvés`
          };
        }
      }
      
      // Sinon récupérer de toutes les boutiques
      return await userService.getAllUsersFromAllBoutiques(filters);
      
    } catch (error) {
      console.error('❌ Erreur getAllUsers:', error);
      return {
        success: false,
        message: 'Erreur lors de la récupération des utilisateurs'
      };
    }
  }
};

export default userService;